import { render, staticRenderFns } from "./index_for_person.vue?vue&type=template&id=bb67fc68&scoped=true&"
import script from "./index_for_person.vue?vue&type=script&lang=js&"
export * from "./index_for_person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb67fc68",
  null
  
)

export default component.exports